module.exports = __webpack_public_path__ + "static/media/user.2f7c1e75.svg";